import React from 'react';
import '../cssfiles/Spinner.css';


const Spinner = ({size,color,speed})=>{
    const spinnerStyle = {
        width:size,
        height:size,
        border:`${color} transparent ${color} transparent`,
        animationDuration:speed,
    }

    return <div className='spinner-overlay'>
            <div className='spinner' style={spinnerStyle}></div>
    </div>
}

export default Spinner